export default __webpack_public_path__ + "static/char-v-05-396fec979bf716f38271509f4c123659.mp4";